var Ee = Object.defineProperty;
var ke = (e, r, n) => r in e ? Ee(e, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[r] = n;
var k = (e, r, n) => ke(e, typeof r != "symbol" ? r + "" : r, n);
var Oe = Object.defineProperty, Ae = (e, r, n) => r in e ? Oe(e, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[r] = n, b = (e, r, n) => Ae(e, typeof r != "symbol" ? r + "" : r, n);
class Ce {
  constructor() {
    b(this, "expService"), b(this, "expressionBuilder"), b(this, "getExpService", () => {
      if (!this.expService)
        throw new Error("[ExpService] is not initialized");
      return this.expService;
    }), b(this, "setExpService", (r) => {
      this.expService = r;
    }), b(this, "getExpressionBuilder", () => {
      if (!this.expressionBuilder)
        throw new Error("[ExpressionBuilder] is not initialized");
      return this.expressionBuilder;
    }), b(this, "setExpressionBuilder", (r) => {
      this.expressionBuilder = r;
    });
  }
}
const de = "root", G = `${de}.`;
class Pe {
  constructor() {
    k(this, "indexReplacement", (r) => r);
    k(this, "resolveAttributePath", (r) => r.startsWith(G) ? r : `${G}${r}`);
  }
  sizeOf(r) {
    return `size(${r})`;
  }
}
function Re(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var O = { exports: {} }, A = { exports: {} }, U;
function m() {
  return U || (U = 1, function(e) {
    function r(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(A)), A.exports;
}
var C = { exports: {} }, P = { exports: {} }, R = { exports: {} }, W;
function xe() {
  return W || (W = 1, function(e) {
    function r(n) {
      "@babel/helpers - typeof";
      return e.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
        return typeof t;
      } : function(t) {
        return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r(n);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(R)), R.exports;
}
var T = { exports: {} }, X;
function Te() {
  return X || (X = 1, function(e) {
    var r = xe().default;
    function n(t, a) {
      if (r(t) != "object" || !t) return t;
      var i = t[Symbol.toPrimitive];
      if (i !== void 0) {
        var u = i.call(t, a || "default");
        if (r(u) != "object") return u;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (a === "string" ? String : Number)(t);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(T)), T.exports;
}
var Z;
function me() {
  return Z || (Z = 1, function(e) {
    var r = xe().default, n = Te();
    function t(a) {
      var i = n(a, "string");
      return r(i) == "symbol" ? i : i + "";
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(P)), P.exports;
}
var Q;
function qe() {
  return Q || (Q = 1, function(e) {
    var r = me();
    function n(t, a, i) {
      return (a = r(a)) in t ? Object.defineProperty(t, a, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[a] = i, t;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(C)), C.exports;
}
var q = { exports: {} }, Y;
function S() {
  return Y || (Y = 1, function(e) {
    function r(n, t) {
      if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(q)), q.exports;
}
var w = { exports: {} }, ee;
function E() {
  return ee || (ee = 1, function(e) {
    var r = me();
    function n(a, i) {
      for (var u = 0; u < i.length; u++) {
        var s = i[u];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(a, r(s.key), s);
      }
    }
    function t(a, i, u) {
      return i && n(a.prototype, i), u && n(a, u), Object.defineProperty(a, "prototype", {
        writable: !1
      }), a;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(w)), w.exports;
}
var x = {}, j = { exports: {} }, B = { exports: {} }, F = { exports: {} }, re;
function be() {
  return re || (re = 1, function(e) {
    function r(n, t) {
      (t == null || t > n.length) && (t = n.length);
      for (var a = 0, i = Array(t); a < t; a++) i[a] = n[a];
      return i;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(F)), F.exports;
}
var te;
function we() {
  return te || (te = 1, function(e) {
    var r = be();
    function n(t) {
      if (Array.isArray(t)) return r(t);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(B)), B.exports;
}
var I = { exports: {} }, ne;
function je() {
  return ne || (ne = 1, function(e) {
    function r(n) {
      if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(I)), I.exports;
}
var M = { exports: {} }, ae;
function Be() {
  return ae || (ae = 1, function(e) {
    var r = be();
    function n(t, a) {
      if (t) {
        if (typeof t == "string") return r(t, a);
        var i = {}.toString.call(t).slice(8, -1);
        return i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set" ? Array.from(t) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? r(t, a) : void 0;
      }
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(M)), M.exports;
}
var D = { exports: {} }, ie;
function Fe() {
  return ie || (ie = 1, function(e) {
    function r() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(D)), D.exports;
}
var se;
function Ie() {
  return se || (se = 1, function(e) {
    var r = we(), n = je(), t = Be(), a = Fe();
    function i(u) {
      return r(u) || n(u) || t(u) || a();
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(j)), j.exports;
}
var oe;
function Me() {
  if (oe) return x;
  oe = 1;
  var e = m(), r = e(Ie()), n = {
    functions: "Jexl Function",
    transforms: "Transform"
  };
  return x.ArrayLiteral = function(t) {
    return this.evalArray(t.value);
  }, x.BinaryExpression = function(t) {
    var a = this, i = this._grammar.elements[t.operator];
    if (i.evalOnDemand) {
      var u = function(c) {
        return {
          eval: function() {
            return a.eval(c);
          }
        };
      };
      return i.evalOnDemand(u(t.left), u(t.right));
    }
    return this.Promise.all([this.eval(t.left), this.eval(t.right)]).then(function(s) {
      return i.eval(s[0], s[1]);
    });
  }, x.ConditionalExpression = function(t) {
    var a = this;
    return this.eval(t.test).then(function(i) {
      return i ? t.consequent ? a.eval(t.consequent) : i : a.eval(t.alternate);
    });
  }, x.FilterExpression = function(t) {
    var a = this;
    return this.eval(t.subject).then(function(i) {
      return t.relative ? a._filterRelative(i, t.expr) : a._filterStatic(i, t.expr);
    });
  }, x.Identifier = function(t) {
    return t.from ? this.eval(t.from).then(function(a) {
      if (a != null)
        return Array.isArray(a) && (a = a[0]), a[t.value];
    }) : t.relative ? this._relContext[t.value] : this._context[t.value];
  }, x.Literal = function(t) {
    return t.value;
  }, x.ObjectLiteral = function(t) {
    return this.evalMap(t.value);
  }, x.FunctionCall = function(t) {
    var a = n[t.pool];
    if (!a)
      throw new Error("Corrupt AST: Pool '".concat(t.pool, "' not found"));
    var i = this._grammar[t.pool], u = i[t.name];
    if (!u)
      throw new Error("".concat(a, " ").concat(t.name, " is not defined."));
    return this.evalArray(t.args || []).then(function(s) {
      return u.apply(void 0, (0, r.default)(s));
    });
  }, x.UnaryExpression = function(t) {
    var a = this;
    return this.eval(t.right).then(function(i) {
      return a._grammar.elements[t.operator].eval(i);
    });
  }, x;
}
var L, ue;
function De() {
  if (ue) return L;
  ue = 1;
  var e = m(), r = e(S()), n = e(E()), t = Me(), a = /* @__PURE__ */ function() {
    function i(u, s, c) {
      var p = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Promise;
      (0, r.default)(this, i), this._grammar = u, this._context = s || {}, this._relContext = c || this._context, this.Promise = p;
    }
    return (0, n.default)(i, [{
      key: "eval",
      value: function(s) {
        var c = this;
        return this.Promise.resolve().then(function() {
          return t[s.type].call(c, s);
        });
      }
      /**
       * Simultaneously evaluates each expression within an array, and delivers the
       * response as an array with the resulting values at the same indexes as their
       * originating expressions.
       * @param {Array<string>} arr An array of expression strings to be evaluated
       * @returns {Promise<Array<{}>>} resolves with the result array
       */
    }, {
      key: "evalArray",
      value: function(s) {
        var c = this;
        return this.Promise.all(s.map(function(p) {
          return c.eval(p);
        }));
      }
      /**
       * Simultaneously evaluates each expression within a map, and delivers the
       * response as a map with the same keys, but with the evaluated result for each
       * as their value.
       * @param {{}} map A map of expression names to expression trees to be
       *      evaluated
       * @returns {Promise<{}>} resolves with the result map.
       */
    }, {
      key: "evalMap",
      value: function(s) {
        var c = this, p = Object.keys(s), l = {}, f = p.map(function(v) {
          return c.eval(s[v]);
        });
        return this.Promise.all(f).then(function(v) {
          return v.forEach(function(o, h) {
            l[p[h]] = o;
          }), l;
        });
      }
      /**
       * Applies a filter expression with relative identifier elements to a subject.
       * The intent is for the subject to be an array of subjects that will be
       * individually used as the relative context against the provided expression
       * tree. Only the elements whose expressions result in a truthy value will be
       * included in the resulting array.
       *
       * If the subject is not an array of values, it will be converted to a single-
       * element array before running the filter.
       * @param {*} subject The value to be filtered usually an array. If this value is
       *      not an array, it will be converted to an array with this value as the
       *      only element.
       * @param {{}} expr The expression tree to run against each subject. If the
       *      tree evaluates to a truthy result, then the value will be included in
       *      the returned array otherwise, it will be eliminated.
       * @returns {Promise<Array>} resolves with an array of values that passed the
       *      expression filter.
       * @private
       */
    }, {
      key: "_filterRelative",
      value: function(s, c) {
        var p = this, l = [];
        return Array.isArray(s) || (s = s === void 0 ? [] : [s]), s.forEach(function(f) {
          var v = new i(p._grammar, p._context, f, p.Promise);
          l.push(v.eval(c));
        }), this.Promise.all(l).then(function(f) {
          var v = [];
          return f.forEach(function(o, h) {
            o && v.push(s[h]);
          }), v;
        });
      }
      /**
       * Applies a static filter expression to a subject value.  If the filter
       * expression evaluates to boolean true, the subject is returned if false,
       * undefined.
       *
       * For any other resulting value of the expression, this function will attempt
       * to respond with the property at that name or index of the subject.
       * @param {*} subject The value to be filtered.  Usually an Array (for which
       *      the expression would generally resolve to a numeric index) or an
       *      Object (for which the expression would generally resolve to a string
       *      indicating a property name)
       * @param {{}} expr The expression tree to run against the subject
       * @returns {Promise<*>} resolves with the value of the drill-down.
       * @private
       */
    }, {
      key: "_filterStatic",
      value: function(s, c) {
        return this.eval(c).then(function(p) {
          return typeof p == "boolean" ? p ? s : void 0 : s[p];
        });
      }
    }]), i;
  }();
  return L = a, L;
}
var V, le;
function Le() {
  if (le) return V;
  le = 1;
  var e = m(), r = e(S()), n = e(E()), t = /^-?(?:(?:[0-9]*\.[0-9]+)|[0-9]+)$/, a = /^[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][a-zA-Zа-яА-Я0-9_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*$/, i = /\\\\/, u = /^\s*$/, s = [
    // Strings
    "'(?:(?:\\\\')|[^'])*'",
    '"(?:(?:\\\\")|[^"])*"',
    // Whitespace
    "\\s+",
    // Booleans
    "\\btrue\\b",
    "\\bfalse\\b"
  ], c = [
    // Identifiers
    "[a-zA-Zа-яА-Я_À-ÖØ-öø-ÿ\\$][a-zA-Z0-9а-яА-Я_À-ÖØ-öø-ÿ\\$]*",
    // Numerics (without negative symbol)
    "(?:(?:[0-9]*\\.[0-9]+)|[0-9]+)"
  ], p = ["binaryOp", "unaryOp", "openParen", "openBracket", "question", "colon"], l = /* @__PURE__ */ function() {
    function f(v) {
      (0, r.default)(this, f), this._grammar = v;
    }
    return (0, n.default)(f, [{
      key: "getElements",
      value: function(o) {
        var h = this._getSplitRegex();
        return o.split(h).filter(function(_) {
          return _;
        });
      }
      /**
       * Converts an array of expression elements into an array of tokens.  Note that
       * the resulting array may not equal the element array in length, as any
       * elements that consist only of whitespace get appended to the previous
       * token's "raw" property.  For the structure of a token object, please see
       * {@link Lexer#tokenize}.
       * @param {Array<string>} elements An array of Jexl expression elements to be
       *      converted to tokens
       * @returns {Array<{type, value, raw}>} an array of token objects.
       */
    }, {
      key: "getTokens",
      value: function(o) {
        for (var h = [], _ = !1, d = 0; d < o.length; d++)
          this._isWhitespace(o[d]) ? h.length && (h[h.length - 1].raw += o[d]) : o[d] === "-" && this._isNegative(h) ? _ = !0 : (_ && (o[d] = "-" + o[d], _ = !1), h.push(this._createToken(o[d])));
        return _ && h.push(this._createToken("-")), h;
      }
      /**
       * Converts a Jexl string into an array of tokens.  Each token is an object
       * in the following format:
       *
       *     {
       *         type: <string>,
       *         [name]: <string>,
       *         value: <boolean|number|string>,
       *         raw: <string>
       *     }
       *
       * Type is one of the following:
       *
       *      literal, identifier, binaryOp, unaryOp
       *
       * OR, if the token is a control character its type is the name of the element
       * defined in the Grammar.
       *
       * Name appears only if the token is a control string found in
       * {@link grammar#elements}, and is set to the name of the element.
       *
       * Value is the value of the token in the correct type (boolean or numeric as
       * appropriate). Raw is the string representation of this value taken directly
       * from the expression string, including any trailing spaces.
       * @param {string} str The Jexl string to be tokenized
       * @returns {Array<{type, value, raw}>} an array of token objects.
       * @throws {Error} if the provided string contains an invalid token.
       */
    }, {
      key: "tokenize",
      value: function(o) {
        var h = this.getElements(o);
        return this.getTokens(h);
      }
      /**
       * Creates a new token object from an element of a Jexl string. See
       * {@link Lexer#tokenize} for a description of the token object.
       * @param {string} element The element from which a token should be made
       * @returns {{value: number|boolean|string, [name]: string, type: string,
       *      raw: string}} a token object describing the provided element.
       * @throws {Error} if the provided string is not a valid expression element.
       * @private
       */
    }, {
      key: "_createToken",
      value: function(o) {
        var h = {
          type: "literal",
          value: o,
          raw: o
        };
        if (o[0] === '"' || o[0] === "'")
          h.value = this._unquote(o);
        else if (o.match(t))
          h.value = parseFloat(o);
        else if (o === "true" || o === "false")
          h.value = o === "true";
        else if (this._grammar.elements[o])
          h.type = this._grammar.elements[o].type;
        else if (o.match(a))
          h.type = "identifier";
        else
          throw new Error("Invalid expression token: ".concat(o));
        return h;
      }
      /**
       * Escapes a string so that it can be treated as a string literal within a
       * regular expression.
       * @param {string} str The string to be escaped
       * @returns {string} the RegExp-escaped string.
       * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions
       * @private
       */
    }, {
      key: "_escapeRegExp",
      value: function(o) {
        return o = o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), o.match(a) && (o = "\\b" + o + "\\b"), o;
      }
      /**
       * Gets a RegEx object appropriate for splitting a Jexl string into its core
       * elements.
       * @returns {RegExp} An element-splitting RegExp object
       * @private
       */
    }, {
      key: "_getSplitRegex",
      value: function() {
        var o = this;
        if (!this._splitRegex) {
          var h = Object.keys(this._grammar.elements).sort(function(_, d) {
            return d.length - _.length;
          }).map(function(_) {
            return o._escapeRegExp(_);
          }, this);
          this._splitRegex = new RegExp("(" + [s.join("|"), h.join("|"), c.join("|")].join("|") + ")");
        }
        return this._splitRegex;
      }
      /**
       * Determines whether the addition of a '-' token should be interpreted as a
       * negative symbol for an upcoming number, given an array of tokens already
       * processed.
       * @param {Array<Object>} tokens An array of tokens already processed
       * @returns {boolean} true if adding a '-' should be considered a negative
       *      symbol; false otherwise
       * @private
       */
    }, {
      key: "_isNegative",
      value: function(o) {
        return o.length ? p.some(function(h) {
          return h === o[o.length - 1].type;
        }) : !0;
      }
      /**
       * A utility function to determine if a string consists of only space
       * characters.
       * @param {string} str A string to be tested
       * @returns {boolean} true if the string is empty or consists of only spaces;
       *      false otherwise.
       * @private
       */
    }, {
      key: "_isWhitespace",
      value: function(o) {
        return !!o.match(u);
      }
      /**
       * Removes the beginning and trailing quotes from a string, unescapes any
       * escaped quotes on its interior, and unescapes any escaped escape
       * characters. Note that this function is not defensive; it assumes that the
       * provided string is not empty, and that its first and last characters are
       * actually quotes.
       * @param {string} str A string whose first and last characters are quotes
       * @returns {string} a string with the surrounding quotes stripped and escapes
       *      properly processed.
       * @private
       */
    }, {
      key: "_unquote",
      value: function(o) {
        var h = o[0], _ = new RegExp("\\\\" + h, "g");
        return o.substr(1, o.length - 2).replace(_, h).replace(i, "\\");
      }
    }]), f;
  }();
  return V = l, V;
}
var y = {}, ce;
function ge() {
  return ce || (ce = 1, y.argVal = function(e) {
    e && this._cursor.args.push(e);
  }, y.arrayStart = function() {
    this._placeAtCursor({
      type: "ArrayLiteral",
      value: []
    });
  }, y.arrayVal = function(e) {
    e && this._cursor.value.push(e);
  }, y.binaryOp = function(e) {
    for (var r = this._grammar.elements[e.value].precedence || 0, n = this._cursor._parent; n && n.operator && this._grammar.elements[n.operator].precedence >= r; )
      this._cursor = n, n = n._parent;
    var t = {
      type: "BinaryExpression",
      operator: e.value,
      left: this._cursor
    };
    this._setParent(this._cursor, t), this._cursor = n, this._placeAtCursor(t);
  }, y.dot = function() {
    this._nextIdentEncapsulate = this._cursor && this._cursor.type !== "UnaryExpression" && (this._cursor.type !== "BinaryExpression" || this._cursor.type === "BinaryExpression" && this._cursor.right), this._nextIdentRelative = !this._cursor || this._cursor && !this._nextIdentEncapsulate, this._nextIdentRelative && (this._relative = !0);
  }, y.filter = function(e) {
    this._placeBeforeCursor({
      type: "FilterExpression",
      expr: e,
      relative: this._subParser.isRelative(),
      subject: this._cursor
    });
  }, y.functionCall = function() {
    this._placeBeforeCursor({
      type: "FunctionCall",
      name: this._cursor.value,
      args: [],
      pool: "functions"
    });
  }, y.identifier = function(e) {
    var r = {
      type: "Identifier",
      value: e.value
    };
    this._nextIdentEncapsulate ? (r.from = this._cursor, this._placeBeforeCursor(r), this._nextIdentEncapsulate = !1) : (this._nextIdentRelative && (r.relative = !0, this._nextIdentRelative = !1), this._placeAtCursor(r));
  }, y.literal = function(e) {
    this._placeAtCursor({
      type: "Literal",
      value: e.value
    });
  }, y.objKey = function(e) {
    this._curObjKey = e.value;
  }, y.objStart = function() {
    this._placeAtCursor({
      type: "ObjectLiteral",
      value: {}
    });
  }, y.objVal = function(e) {
    this._cursor.value[this._curObjKey] = e;
  }, y.subExpression = function(e) {
    this._placeAtCursor(e);
  }, y.ternaryEnd = function(e) {
    this._cursor.alternate = e;
  }, y.ternaryMid = function(e) {
    this._cursor.consequent = e;
  }, y.ternaryStart = function() {
    this._tree = {
      type: "ConditionalExpression",
      test: this._tree
    }, this._cursor = this._tree;
  }, y.transform = function(e) {
    this._placeBeforeCursor({
      type: "FunctionCall",
      name: e.value,
      args: [this._cursor],
      pool: "transforms"
    });
  }, y.unaryOp = function(e) {
    this._placeAtCursor({
      type: "UnaryExpression",
      operator: e.value
    });
  }), y;
}
var $ = {}, pe;
function Ve() {
  if (pe) return $;
  pe = 1;
  var e = ge();
  return $.states = {
    expectOperand: {
      tokenTypes: {
        literal: {
          toState: "expectBinOp"
        },
        identifier: {
          toState: "identifier"
        },
        unaryOp: {},
        openParen: {
          toState: "subExpression"
        },
        openCurl: {
          toState: "expectObjKey",
          handler: e.objStart
        },
        dot: {
          toState: "traverse"
        },
        openBracket: {
          toState: "arrayVal",
          handler: e.arrayStart
        }
      }
    },
    expectBinOp: {
      tokenTypes: {
        binaryOp: {
          toState: "expectOperand"
        },
        pipe: {
          toState: "expectTransform"
        },
        dot: {
          toState: "traverse"
        },
        question: {
          toState: "ternaryMid",
          handler: e.ternaryStart
        }
      },
      completable: !0
    },
    expectTransform: {
      tokenTypes: {
        identifier: {
          toState: "postTransform",
          handler: e.transform
        }
      }
    },
    expectObjKey: {
      tokenTypes: {
        identifier: {
          toState: "expectKeyValSep",
          handler: e.objKey
        },
        closeCurl: {
          toState: "expectBinOp"
        }
      }
    },
    expectKeyValSep: {
      tokenTypes: {
        colon: {
          toState: "objVal"
        }
      }
    },
    postTransform: {
      tokenTypes: {
        openParen: {
          toState: "argVal"
        },
        binaryOp: {
          toState: "expectOperand"
        },
        dot: {
          toState: "traverse"
        },
        openBracket: {
          toState: "filter"
        },
        pipe: {
          toState: "expectTransform"
        }
      },
      completable: !0
    },
    postArgs: {
      tokenTypes: {
        binaryOp: {
          toState: "expectOperand"
        },
        dot: {
          toState: "traverse"
        },
        openBracket: {
          toState: "filter"
        },
        pipe: {
          toState: "expectTransform"
        }
      },
      completable: !0
    },
    identifier: {
      tokenTypes: {
        binaryOp: {
          toState: "expectOperand"
        },
        dot: {
          toState: "traverse"
        },
        openBracket: {
          toState: "filter"
        },
        openParen: {
          toState: "argVal",
          handler: e.functionCall
        },
        pipe: {
          toState: "expectTransform"
        },
        question: {
          toState: "ternaryMid",
          handler: e.ternaryStart
        }
      },
      completable: !0
    },
    traverse: {
      tokenTypes: {
        identifier: {
          toState: "identifier"
        }
      }
    },
    filter: {
      subHandler: e.filter,
      endStates: {
        closeBracket: "identifier"
      }
    },
    subExpression: {
      subHandler: e.subExpression,
      endStates: {
        closeParen: "expectBinOp"
      }
    },
    argVal: {
      subHandler: e.argVal,
      endStates: {
        comma: "argVal",
        closeParen: "postArgs"
      }
    },
    objVal: {
      subHandler: e.objVal,
      endStates: {
        comma: "expectObjKey",
        closeCurl: "expectBinOp"
      }
    },
    arrayVal: {
      subHandler: e.arrayVal,
      endStates: {
        comma: "arrayVal",
        closeBracket: "expectBinOp"
      }
    },
    ternaryMid: {
      subHandler: e.ternaryMid,
      endStates: {
        colon: "ternaryEnd"
      }
    },
    ternaryEnd: {
      subHandler: e.ternaryEnd,
      completable: !0
    }
  }, $;
}
var H, fe;
function $e() {
  if (fe) return H;
  fe = 1;
  var e = m(), r = e(S()), n = e(E()), t = ge(), a = Ve().states, i = /* @__PURE__ */ function() {
    function u(s, c, p) {
      (0, r.default)(this, u), this._grammar = s, this._state = "expectOperand", this._tree = null, this._exprStr = c || "", this._relative = !1, this._stopMap = p || {};
    }
    return (0, n.default)(u, [{
      key: "addToken",
      value: function(c) {
        if (this._state === "complete")
          throw new Error("Cannot add a new token to a completed Parser");
        var p = a[this._state], l = this._exprStr;
        if (this._exprStr += c.raw, p.subHandler) {
          this._subParser || this._startSubExpression(l);
          var f = this._subParser.addToken(c);
          if (f) {
            if (this._endSubExpression(), this._parentStop) return f;
            this._state = f;
          }
        } else if (p.tokenTypes[c.type]) {
          var v = p.tokenTypes[c.type], o = t[c.type];
          v.handler && (o = v.handler), o && o.call(this, c), v.toState && (this._state = v.toState);
        } else {
          if (this._stopMap[c.type])
            return this._stopMap[c.type];
          throw new Error("Token ".concat(c.raw, " (").concat(c.type, ") unexpected in expression: ").concat(this._exprStr));
        }
        return !1;
      }
      /**
       * Processes an array of tokens iteratively through the {@link #addToken}
       * function.
       * @param {Array<{type: <string>}>} tokens An array of tokens, as provided by
       *      the {@link Lexer#tokenize} function.
       */
    }, {
      key: "addTokens",
      value: function(c) {
        c.forEach(this.addToken, this);
      }
      /**
       * Marks this Parser instance as completed and retrieves the full AST.
       * @returns {{}|null} a full expression tree, ready for evaluation by the
       *      {@link Evaluator#eval} function, or null if no tokens were passed to
       *      the parser before complete was called
       * @throws {Error} if the parser is not in a state where it's legal to end
       *      the expression, indicating that the expression is incomplete
       */
    }, {
      key: "complete",
      value: function() {
        if (this._cursor && !a[this._state].completable)
          throw new Error("Unexpected end of expression: ".concat(this._exprStr));
        return this._subParser && this._endSubExpression(), this._state = "complete", this._cursor ? this._tree : null;
      }
      /**
       * Indicates whether the expression tree contains a relative path identifier.
       * @returns {boolean} true if a relative identifier exists false otherwise.
       */
    }, {
      key: "isRelative",
      value: function() {
        return this._relative;
      }
      /**
       * Ends a subexpression by completing the subParser and passing its result
       * to the subHandler configured in the current state.
       * @private
       */
    }, {
      key: "_endSubExpression",
      value: function() {
        a[this._state].subHandler.call(this, this._subParser.complete()), this._subParser = null;
      }
      /**
       * Places a new tree node at the current position of the cursor (to the 'right'
       * property) and then advances the cursor to the new node. This function also
       * handles setting the parent of the new node.
       * @param {{type: <string>}} node A node to be added to the AST
       * @private
       */
    }, {
      key: "_placeAtCursor",
      value: function(c) {
        this._cursor ? (this._cursor.right = c, this._setParent(c, this._cursor)) : this._tree = c, this._cursor = c;
      }
      /**
       * Places a tree node before the current position of the cursor, replacing
       * the node that the cursor currently points to. This should only be called in
       * cases where the cursor is known to exist, and the provided node already
       * contains a pointer to what's at the cursor currently.
       * @param {{type: <string>}} node A node to be added to the AST
       * @private
       */
    }, {
      key: "_placeBeforeCursor",
      value: function(c) {
        this._cursor = this._cursor._parent, this._placeAtCursor(c);
      }
      /**
       * Sets the parent of a node by creating a non-enumerable _parent property
       * that points to the supplied parent argument.
       * @param {{type: <string>}} node A node of the AST on which to set a new
       *      parent
       * @param {{type: <string>}} parent An existing node of the AST to serve as the
       *      parent of the new node
       * @private
       */
    }, {
      key: "_setParent",
      value: function(c, p) {
        Object.defineProperty(c, "_parent", {
          value: p,
          writable: !0
        });
      }
      /**
       * Prepares the Parser to accept a subexpression by (re)instantiating the
       * subParser.
       * @param {string} [exprStr] The expression string to prefix to the new Parser
       * @private
       */
    }, {
      key: "_startSubExpression",
      value: function(c) {
        var p = a[this._state].endStates;
        p || (this._parentStop = !0, p = this._stopMap), this._subParser = new u(this._grammar, c, p);
      }
    }]), u;
  }();
  return H = i, H;
}
var K, ve;
function He() {
  if (ve) return K;
  ve = 1;
  var e = m(), r = e(S()), n = e(E()), t = /* @__PURE__ */ function() {
    function a(i) {
      (0, r.default)(this, a), i(this._resolve.bind(this), this._reject.bind(this));
    }
    return (0, n.default)(a, [{
      key: "catch",
      value: function(u) {
        if (this.error)
          try {
            this._resolve(u(this.error));
          } catch (s) {
            this._reject(s);
          }
        return this;
      }
    }, {
      key: "then",
      value: function(u, s) {
        if (!this.error)
          try {
            this._resolve(u(this.value));
          } catch (c) {
            this._reject(c);
          }
        return s && this.catch(s), this;
      }
    }, {
      key: "_reject",
      value: function(u) {
        this.value = void 0, this.error = u;
      }
    }, {
      key: "_resolve",
      value: function(u) {
        u instanceof a ? u.error ? this._reject(u.error) : this._resolve(u.value) : (this.value = u, this.error = void 0);
      }
    }]), a;
  }();
  return t.all = function(a) {
    return new t(function(i) {
      var u = a.map(function(s) {
        for (; s instanceof t; ) {
          if (s.error) throw Error(s.error);
          s = s.value;
        }
        return s;
      });
      i(u);
    });
  }, t.resolve = function(a) {
    return new t(function(i) {
      return i(a);
    });
  }, t.reject = function(a) {
    return new t(function(i, u) {
      return u(a);
    });
  }, K = t, K;
}
var z, he;
function Ke() {
  if (he) return z;
  he = 1;
  var e = m(), r = e(S()), n = e(E()), t = De(), a = Le(), i = $e(), u = He(), s = /* @__PURE__ */ function() {
    function c(p, l) {
      (0, r.default)(this, c), this._grammar = p, this._exprStr = l, this._ast = null;
    }
    return (0, n.default)(c, [{
      key: "compile",
      value: function() {
        var l = new a(this._grammar), f = new i(this._grammar), v = l.tokenize(this._exprStr);
        return f.addTokens(v), this._ast = f.complete(), this;
      }
      /**
       * Asynchronously evaluates the expression within an optional context.
       * @param {Object} [context] A mapping of variables to values, which will be
       *      made accessible to the Jexl expression when evaluating it
       * @returns {Promise<*>} resolves with the result of the evaluation.
       */
    }, {
      key: "eval",
      value: function() {
        var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return this._eval(l, Promise);
      }
      /**
       * Synchronously evaluates the expression within an optional context.
       * @param {Object} [context] A mapping of variables to values, which will be
       *      made accessible to the Jexl expression when evaluating it
       * @returns {*} the result of the evaluation.
       * @throws {*} on error
       */
    }, {
      key: "evalSync",
      value: function() {
        var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = this._eval(l, u);
        if (f.error) throw f.error;
        return f.value;
      }
    }, {
      key: "_eval",
      value: function(l, f) {
        var v = this;
        return f.resolve().then(function() {
          var o = v._getAst(), h = new t(v._grammar, l, void 0, f);
          return h.eval(o);
        });
      }
    }, {
      key: "_getAst",
      value: function() {
        return this._ast || this.compile(), this._ast;
      }
    }]), c;
  }();
  return z = s, z;
}
var J = {}, ye;
function ze() {
  return ye || (ye = 1, J.getGrammar = function() {
    return {
      /**
       * A map of all expression elements to their properties. Note that changes
       * here may require changes in the Lexer or Parser.
       * @type {{}}
       */
      elements: {
        ".": {
          type: "dot"
        },
        "[": {
          type: "openBracket"
        },
        "]": {
          type: "closeBracket"
        },
        "|": {
          type: "pipe"
        },
        "{": {
          type: "openCurl"
        },
        "}": {
          type: "closeCurl"
        },
        ":": {
          type: "colon"
        },
        ",": {
          type: "comma"
        },
        "(": {
          type: "openParen"
        },
        ")": {
          type: "closeParen"
        },
        "?": {
          type: "question"
        },
        "+": {
          type: "binaryOp",
          precedence: 30,
          eval: function(r, n) {
            return r + n;
          }
        },
        "-": {
          type: "binaryOp",
          precedence: 30,
          eval: function(r, n) {
            return r - n;
          }
        },
        "*": {
          type: "binaryOp",
          precedence: 40,
          eval: function(r, n) {
            return r * n;
          }
        },
        "/": {
          type: "binaryOp",
          precedence: 40,
          eval: function(r, n) {
            return r / n;
          }
        },
        "//": {
          type: "binaryOp",
          precedence: 40,
          eval: function(r, n) {
            return Math.floor(r / n);
          }
        },
        "%": {
          type: "binaryOp",
          precedence: 50,
          eval: function(r, n) {
            return r % n;
          }
        },
        "^": {
          type: "binaryOp",
          precedence: 50,
          eval: function(r, n) {
            return Math.pow(r, n);
          }
        },
        "==": {
          type: "binaryOp",
          precedence: 20,
          eval: function(r, n) {
            return r == n;
          }
        },
        "!=": {
          type: "binaryOp",
          precedence: 20,
          eval: function(r, n) {
            return r != n;
          }
        },
        ">": {
          type: "binaryOp",
          precedence: 20,
          eval: function(r, n) {
            return r > n;
          }
        },
        ">=": {
          type: "binaryOp",
          precedence: 20,
          eval: function(r, n) {
            return r >= n;
          }
        },
        "<": {
          type: "binaryOp",
          precedence: 20,
          eval: function(r, n) {
            return r < n;
          }
        },
        "<=": {
          type: "binaryOp",
          precedence: 20,
          eval: function(r, n) {
            return r <= n;
          }
        },
        "&&": {
          type: "binaryOp",
          precedence: 10,
          evalOnDemand: function(r, n) {
            return r.eval().then(function(t) {
              return t && n.eval();
            });
          }
        },
        "||": {
          type: "binaryOp",
          precedence: 10,
          evalOnDemand: function(r, n) {
            return r.eval().then(function(t) {
              return t || n.eval();
            });
          }
        },
        in: {
          type: "binaryOp",
          precedence: 20,
          eval: function(r, n) {
            return typeof n == "string" ? n.indexOf(r) !== -1 : Array.isArray(n) ? n.some(function(t) {
              return t === r;
            }) : !1;
          }
        },
        "!": {
          type: "unaryOp",
          precedence: 1 / 0,
          eval: function(r) {
            return !r;
          }
        }
      },
      /**
       * A map of function names to javascript functions. A Jexl function
       * takes zero ore more arguemnts:
       *
       *     - {*} ...args: A variable number of arguments passed to this function.
       *       All of these are pre-evaluated to their actual values before calling
       *       the function.
       *
       * The Jexl function should return either the transformed value, or
       * a Promises/A+ Promise object that resolves with the value and rejects
       * or throws only when an unrecoverable error occurs. Functions should
       * generally return undefined when they don't make sense to be used on the
       * given value type, rather than throw/reject. An error is only
       * appropriate when the function would normally return a value, but
       * cannot due to some other failure.
       */
      functions: {},
      /**
       * A map of transform names to transform functions. A transform function
       * takes one ore more arguemnts:
       *
       *     - {*} val: A value to be transformed
       *     - {*} ...args: A variable number of arguments passed to this transform.
       *       All of these are pre-evaluated to their actual values before calling
       *       the function.
       *
       * The transform function should return either the transformed value, or
       * a Promises/A+ Promise object that resolves with the value and rejects
       * or throws only when an unrecoverable error occurs. Transforms should
       * generally return undefined when they don't make sense to be used on the
       * given value type, rather than throw/reject. An error is only
       * appropriate when the transform would normally return a value, but
       * cannot due to some other failure.
       */
      transforms: {}
    };
  }), J;
}
var _e;
function Je() {
  if (_e) return O.exports;
  _e = 1;
  var e = m(), r = e(qe()), n = e(S()), t = e(E()), a = Ke(), i = ze(), u = i.getGrammar, s = /* @__PURE__ */ function() {
    function c() {
      (0, n.default)(this, c), this.expr = this.expr.bind(this), this._grammar = u();
    }
    return (0, t.default)(c, [{
      key: "addBinaryOp",
      value: function(l, f, v, o) {
        this._addGrammarElement(l, (0, r.default)({
          type: "binaryOp",
          precedence: f
        }, o ? "evalOnDemand" : "eval", v));
      }
      /**
       * Adds or replaces an expression function in this Jexl instance.
       * @param {string} name The name of the expression function, as it will be
       *      used within Jexl expressions
       * @param {function} fn The javascript function to be executed when this
       *      expression function is invoked. It will be provided with each argument
       *      supplied in the expression, in the same order.
       */
    }, {
      key: "addFunction",
      value: function(l, f) {
        this._grammar.functions[l] = f;
      }
      /**
       * Syntactic sugar for calling {@link #addFunction} repeatedly. This function
       * accepts a map of one or more expression function names to their javascript
       * function counterpart.
       * @param {{}} map A map of expression function names to javascript functions
       */
    }, {
      key: "addFunctions",
      value: function(l) {
        for (var f in l)
          this._grammar.functions[f] = l[f];
      }
      /**
       * Adds a unary operator to Jexl. Unary operators are currently only supported
       * on the left side of the value on which it will operate.
       * @param {string} operator The operator string to be added
       * @param {function} fn A function to run to calculate the result. The function
       *      will be called with one argument: the literal value to the right of the
       *      operator. It should return either the resulting value, or a Promise
       *      that resolves with the resulting value.
       */
    }, {
      key: "addUnaryOp",
      value: function(l, f) {
        this._addGrammarElement(l, {
          type: "unaryOp",
          weight: 1 / 0,
          eval: f
        });
      }
      /**
       * Adds or replaces a transform function in this Jexl instance.
       * @param {string} name The name of the transform function, as it will be used
       *      within Jexl expressions
       * @param {function} fn The function to be executed when this transform is
       *      invoked. It will be provided with at least one argument:
       *          - {*} value: The value to be transformed
       *          - {...*} args: The arguments for this transform
       */
    }, {
      key: "addTransform",
      value: function(l, f) {
        this._grammar.transforms[l] = f;
      }
      /**
       * Syntactic sugar for calling {@link #addTransform} repeatedly.  This function
       * accepts a map of one or more transform names to their transform function.
       * @param {{}} map A map of transform names to transform functions
       */
    }, {
      key: "addTransforms",
      value: function(l) {
        for (var f in l)
          this._grammar.transforms[f] = l[f];
      }
      /**
       * Creates an Expression object from the given Jexl expression string, and
       * immediately compiles it. The returned Expression object can then be
       * evaluated multiple times with new contexts, without generating any
       * additional string processing overhead.
       * @param {string} expression The Jexl expression to be compiled
       * @returns {Expression} The compiled Expression object
       */
    }, {
      key: "compile",
      value: function(l) {
        var f = this.createExpression(l);
        return f.compile();
      }
      /**
       * Constructs an Expression object from a Jexl expression string.
       * @param {string} expression The Jexl expression to be wrapped in an
       *    Expression object
       * @returns {Expression} The Expression object representing the given string
       */
    }, {
      key: "createExpression",
      value: function(l) {
        return new a(this._grammar, l);
      }
      /**
       * Retrieves a previously set expression function.
       * @param {string} name The name of the expression function
       * @returns {function} The expression function
       */
    }, {
      key: "getFunction",
      value: function(l) {
        return this._grammar.functions[l];
      }
      /**
       * Retrieves a previously set transform function.
       * @param {string} name The name of the transform function
       * @returns {function} The transform function
       */
    }, {
      key: "getTransform",
      value: function(l) {
        return this._grammar.transforms[l];
      }
      /**
       * Asynchronously evaluates a Jexl string within an optional context.
       * @param {string} expression The Jexl expression to be evaluated
       * @param {Object} [context] A mapping of variables to values, which will be
       *      made accessible to the Jexl expression when evaluating it
       * @returns {Promise<*>} resolves with the result of the evaluation.
       */
    }, {
      key: "eval",
      value: function(l) {
        var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, v = this.createExpression(l);
        return v.eval(f);
      }
      /**
       * Synchronously evaluates a Jexl string within an optional context.
       * @param {string} expression The Jexl expression to be evaluated
       * @param {Object} [context] A mapping of variables to values, which will be
       *      made accessible to the Jexl expression when evaluating it
       * @returns {*} the result of the evaluation.
       * @throws {*} on error
       */
    }, {
      key: "evalSync",
      value: function(l) {
        var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, v = this.createExpression(l);
        return v.evalSync(f);
      }
      /**
       * A JavaScript template literal to allow expressions to be defined by the
       * syntax: expr`40 + 2`
       * @param {Array<string>} strs
       * @param  {...any} args
       */
    }, {
      key: "expr",
      value: function(l) {
        for (var f = arguments.length, v = new Array(f > 1 ? f - 1 : 0), o = 1; o < f; o++)
          v[o - 1] = arguments[o];
        var h = l.reduce(function(_, d, N) {
          var Se = N < v.length ? v[N] : "";
          return _ += d + Se, _;
        }, "");
        return this.createExpression(h);
      }
      /**
       * Removes a binary or unary operator from the Jexl grammar.
       * @param {string} operator The operator string to be removed
       */
    }, {
      key: "removeOp",
      value: function(l) {
        this._grammar.elements[l] && (this._grammar.elements[l].type === "binaryOp" || this._grammar.elements[l].type === "unaryOp") && delete this._grammar.elements[l];
      }
      /**
       * Adds an element to the grammar map used by this Jexl instance.
       * @param {string} str The key string to be added
       * @param {{type: <string>}} obj A map of configuration options for this
       *      grammar element
       * @private
       */
    }, {
      key: "_addGrammarElement",
      value: function(l, f) {
        this._grammar.elements[l] = f;
      }
    }]), c;
  }();
  return O.exports = new s(), O.exports.Jexl = s, O.exports;
}
var Ne = Je();
const g = /* @__PURE__ */ Re(Ne), Ge = (e) => e == null ? -1 : Array.isArray(e) || typeof e == "string" ? e.length : typeof e == "object" ? Object.keys(e).length : -1, Ue = (e, r, n = {}) => {
  if (!Array.isArray(e))
    return !1;
  for (const t of e) {
    const a = { ...n, it: t };
    if (g.evalSync(r, a) === !0)
      return !0;
  }
  return !1;
}, We = (e, r, n = {}) => {
  if (!Array.isArray(e) || !r)
    return null;
  const t = [];
  for (const a of e) {
    const i = { ...n, it: a }, u = g.evalSync(r, i);
    t.push(u);
  }
  return t;
}, Xe = () => {
  g.addFunction("size", Ge), g.addFunction("anyMatch", Ue), g.addFunction("map", We);
}, Ze = "ctxVariables";
Xe();
class Qe {
  constructor() {
    k(this, "evaluate", (r) => {
      const n = {};
      n[de] = r.data;
      const t = r.variables || {};
      return n[Ze] = t, Object.keys(t).forEach((i) => n[i] = t[i]), { value: g.evalSync(r.expression, n) };
    });
  }
}
const er = () => {
  const e = new Ce();
  return e.setExpService(new Qe()), e.setExpressionBuilder(new Pe()), e;
};
export {
  Pe as JEXLExpressionBuilder,
  Qe as JEXLService,
  de as ROOT_VARIABLE,
  G as ROOT_VARIABLE_PREFIX,
  er as getJEXLExpServiceProvider
};
